/**
 * Constants for ConditionEdge
 * Uses enums from types/enums.ts (auto-generated from Laravel)
 *
 * BE expects FilterSettingsRequest: { validator: FilterType, path: string, value: string }
 * FE mapping:
 * - value → path (full reference, e.g. {parsedBody.key}, {data_surname}, {status})
 * - output → value
 * - operator → validator (FilterType)
 */

import { FilterType } from "types/enums";

/**
 * Operator options using FilterType enum (maps to BE validator field)
 */
export const CONDITION_OPERATOR_OPTIONS = [
    { value: FilterType.Equals, labelKey: "edges.condition.forms.operator_options.equals" },
    { value: FilterType.NotEquals, labelKey: "edges.condition.forms.operator_options.not_equals" },
    { value: FilterType.IsTrue, labelKey: "edges.condition.forms.operator_options.is_true" },
    { value: FilterType.IsFalse, labelKey: "edges.condition.forms.operator_options.is_false" },
    { value: FilterType.IsLessThan, labelKey: "edges.condition.forms.operator_options.is_less_than" },
    { value: FilterType.IsLessThanOrEquals, labelKey: "edges.condition.forms.operator_options.is_less_than_or_equals" },
    { value: FilterType.IsGreaterThan, labelKey: "edges.condition.forms.operator_options.is_greater_than" },
    {
        value: FilterType.IsGreaterThanOrEquals,
        labelKey: "edges.condition.forms.operator_options.is_greater_than_or_equals",
    },
    { value: FilterType.IsBetween, labelKey: "edges.condition.forms.operator_options.is_between" },
    { value: FilterType.IsBetweenEquals, labelKey: "edges.condition.forms.operator_options.is_between_equals" },
    { value: FilterType.Contains, labelKey: "edges.condition.forms.operator_options.contains" },
    { value: FilterType.NotContains, labelKey: "edges.condition.forms.operator_options.not_contains" },
    { value: FilterType.StartsWith, labelKey: "edges.condition.forms.operator_options.starts_with" },
    { value: FilterType.EndsWith, labelKey: "edges.condition.forms.operator_options.ends_with" },
    { value: FilterType.IsEmpty, labelKey: "edges.condition.forms.operator_options.is_empty" },
    { value: FilterType.IsNotEmpty, labelKey: "edges.condition.forms.operator_options.is_not_empty" },
    { value: FilterType.RegexMatch, labelKey: "edges.condition.forms.operator_options.regex_match" },
    { value: FilterType.RegexNotMatch, labelKey: "edges.condition.forms.operator_options.regex_not_match" },
] as const;

export const CONDITION_RESULT_OPTIONS = [
    { value: "success", labelKey: "edges.condition.forms.result_options.success" },
    { value: "failure", labelKey: "edges.condition.forms.result_options.failure" },
    { value: "pending", labelKey: "edges.condition.forms.result_options.pending" },
] as const;
